const POLYCOMS = {
  title: 'Polycom',
  type: 'FSIST300',
  desc: 'US Federal and NATO Practice Specialization',
  detail: [
    {
      type: 'RPEOS100',
      desc: 'Video Endpoints'
    },

    {
      type: 'RPEMOS101',
      desc: 'Introduction to Real Presence Mobile '
    },

    {
      type: 'FSIST300',
      desc: 'Federal Specialization '
    },

    {
      type: 'IVOS200',
      desc: 'Installed Voice'
    },

    {
      type: 'VSOT200',
      desc: 'VoIP Technical Track'
    },

    {
      type: 'C3130610',
      desc: 'Video Solutions'
    },

    {
      type: 'ITPOS100',
      desc: 'Immersive'
    },

    {
      type: 'IBM RPIIAS300',
      desc: 'Integration'
    },

    {
      type: 'RPPOT200',
      desc: 'Platform'
    },

    {
      type: 'RPVOS101',
      desc: 'Primer Training'
    },

  ]
}

export {
  POLYCOMS
}